/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';
import Media from 'react-responsive';
import { compose, onlyUpdateForKeys } from 'recompose';
import { withTheme } from 'styled-components';

import Render from 'components/render';
import { device } from 'helpers/screenSizes';
// import PropTypes from 'PropTypes';
import { SearchIconSymbol, CrossIconSymbol } from 'styles/assets/icons';
import { FormInput } from 'UIKit';

import styles from './search.module.scss';

const SearchMarkets = props => {
  const { t } = useTranslation(['markets']);
  const searchFieldRef = useRef();
  const search = value => props.search(value);

  const onSearchChange = ({ target }) => {
    if (props.showLoader) {
      return;
    } // Don't search when page is still loading
    search(target.value);
  };

  const clearSearch = () => {
    search('');
    searchFieldRef.current.value = '';
  };

  // const selectedContractType = useSelector(contractTypeSelector);
  // const placeholder = (() => {
  //   switch (selectedContractType) {
  //     case 'futures':
  //       return 'Search Futures / Perpetual contracts';
  //     case 'options':
  //       return 'Search Options contracts';
  //     case 'turbo_options':
  //       return 'Search Turbo Options contracts';
  //     case 'interest_rate_swaps':
  //       return 'Search Fixed-Floating Swaps';
  //     case 'spreads':
  //       return 'Search Spreads contracts';
  //     default:
  //       return 'Search';
  //   }
  // })();

  return (
    (<div className={styles.search} data-palette="SearchMarkets">
      <div className={styles['search-input']}>
        <Media query={device.up.md}>
          <SearchIconSymbol
            className={styles['search-icon']}
            color={props.theme.secondaryText}
          />
        </Media>
        <FormInput
          data-testid="qchqBmC2QrJrrvdchS14C"
          placeholder={t('markets:contractHeader.search')}
          value={props.searchValue}
          onChange={onSearchChange}
          spellCheck="false"
          autoComplete="off"
          className="search-markets"
          onClick={props.onClick}
          ref={searchFieldRef}
          reset={props.reset}
        />
        <Render when={props.searchValue}>
          <div
            data-testid="ruXSr2NHp91w82HX4n4vQ"
            aria-hidden="true"
            data-cy="cross"
            className={styles['cross-icon']}
            onClick={clearSearch}
          >
            <CrossIconSymbol color={props.theme.secondaryText} />
          </div>
        </Render>
      </div>
    </div>)
  );
};

// SearchMarkets.propTypes = {
//   searchValue: PropTypes.string.isRequired,
//   search: PropTypes.func.isRequired,
//   noProducts: PropTypes.bool.isRequired,
//   showLoader: PropTypes.bool.isRequired,
//   theme: PropTypes.theme.isRequired,
// };

const enhance = compose(withTheme, onlyUpdateForKeys(['searchValue', 'showLoader']));

export default enhance(SearchMarkets);
